import { debugSession as debug } from 'Lib/debug';

import { APP_PLATFORM_EVENT_HUBBLE_INSTRUMENT } from 'EventModels/app/platformBuilder';
import type { AnalyticsEventActionType } from 'Store/sparks/reporter';
import { HUBBLE_ID_LABELS } from 'Store/sparks/trackers/hubble/constants';

let storeInstance: any = null;

async function getStore() {
  if (!storeInstance) {
    const { getInstance } = await import('../../../../app/store');
    storeInstance = getInstance();
  }
  return storeInstance;
}

function isHubbleEvent(action: AnalyticsEventActionType): boolean {
  return action?.payload?.eventData?.eventData?.schema === APP_PLATFORM_EVENT_HUBBLE_INSTRUMENT;
}

function formatHubbleEventLog(data: any): string {
  const id = data?.id ?? '';
  const label = HUBBLE_ID_LABELS[id] || id;
  const eventText = label ? `"${label}"` : `with ID ${id}`;
  return `Hubble Event ${eventText} Tracked:`;
}

/**
 * Logs Hubble events.
 * Designed to fail silently in test environments or if store initialization fails,
 * to prevent interference with main application flow and component tests.
 */
export async function logHubbleEvent(action: AnalyticsEventActionType): Promise<void> {
  let store;
  try {
    store = await getStore();
  } catch (error) {
    debug('Logging Hubble event failed. Check store initialization.');
    return;
  }
  const { isHubbleDebuggerEnabled } = store.getState().appSettings;

  if (!isHubbleDebuggerEnabled || !isHubbleEvent(action)) return;

  const data = action?.payload?.eventData?.eventData;
  console.log(formatHubbleEventLog(data), data);
}
